import request from './common/request'
import qs from 'qs'

import { MERCHANT_EDUCATION_LIVE_CLASSROOM_URL } from './urls'

// 列表
async function list (params) {
  return request(
    {
      url: MERCHANT_EDUCATION_LIVE_CLASSROOM_URL,
      method: 'GET',
      params: params
    }
  )
}

// 详情
async function getById (id) {
  return request(
    {
      url: `${MERCHANT_EDUCATION_LIVE_CLASSROOM_URL}/${id}`,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: MERCHANT_EDUCATION_LIVE_CLASSROOM_URL,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${MERCHANT_EDUCATION_LIVE_CLASSROOM_URL}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (id) {
  return request(
    {
      url: `${MERCHANT_EDUCATION_LIVE_CLASSROOM_URL}/${id}`,
      method: 'DELETE'
    }
  )
}

async function getLiveClassroomOptions (id) {
  return request(
    {
      url: `${MERCHANT_EDUCATION_LIVE_CLASSROOM_URL}/${id}/liveClassroomOptions`,
      method: 'GET'
    }
  )
}

export default {
  list,
  getById,
  insert,
  update,
  remove,
  getLiveClassroomOptions
}



// WEBPACK FOOTER //
// ./src/api/merchant-education-live-classroom.js